<template>
    <div style="min-height:200px">
        <div>
            <RadioGroup v-model="currentIndex" type="button" size="small">
                <Radio v-for="(item, index) in transformers" :key="index" :label="index">{{transformerFunctions[item.func].title}}</Radio>
            </RadioGroup>
            <Dropdown @on-click="addTransformer" placement='bottom-start'>
                <a href="javascript:void(0)" style="padding-left:10px">
                    添加
                </a>
                <DropdownMenu slot="list" >
                    <DropdownItem v-for="item of transformerFunctions" :key="item.func" :name="item.func">{{item.title}}</DropdownItem>
                </DropdownMenu>
            </Dropdown>
            <a href="javascript:void(0)" @click="removeTransformer">
                删除
            </a>
        </div>
        <span style="color:red">{{this.errorMsg}}</span>
        <Input v-if="transformers[currentIndex]" v-model="transformers[currentIndex].params" type="textarea" :autosize="{minRows: 2,maxRows: 5}" />
        结果数据:{{transformerResult}}
    </div>
</template>
<script>
export default {
    props:['transformers', 'allFunctionsMap', 'orginData'],
    data() {
        return {
            errorMsg:'',
            currentIndex:0,
            transformerResult:''
        }
    },
    computed:{
        transformerFunctions(){
            let result = {};
            for (const key in this.allFunctionsMap) {
                if (this.allFunctionsMap.hasOwnProperty(key)) {
                    const funcDefine = this.allFunctionsMap[key];
                    if(funcDefine.type==='data-transformer'){
                        result[funcDefine.func] = funcDefine;
                    }
                }
            }
            return result;
        },

        currentTransformers(){
            let transformers = [];
            for (let i = 0; i <= this.currentIndex&&this.transformers[i]; i++) {
                const transformer = this.transformers[i];
                transformers.push(transformer)
            }
            return transformers;
        }
    },
    watch: {
        currentTransformers:{
            handler(){
                try {
                    this.errorMsg = '';
                    this.concatFunc(this.orginData, this.currentTransformers, (v)=>{
                        this.transformerResult  = v;
                    })
                } catch (error) {
                    this.errorMsg = error.message;
                }
            },
            deep:true
        }
    },
    methods: {
        addTransformer(func){
            this.transformers.push({
                func:func,
                params:''
            })
            this.currentIndex = this.transformers.length-1;
        },
        removeTransformer(){
            this.transformers.splice(this.currentIndex,1);
            if(this.transformers.length>=this.currentIndex){
                this.currentIndex--;
                this.currentIndex = this.currentIndex<0?0:this.currentIndex;
            }else{
                this.currentIndex=0;
            }
        },
        concatFunc(orginData, funcConfigs, callback) {
            let functions = this.$functions;
            var len = funcConfigs.length;
            let preValue = orginData;
            for (let i = 0; i < funcConfigs.length; i++) {
                const config = funcConfigs[i];
                let nextFunc = createNextFunc(i+1);
                functions[config.func].call(this, preValue, config.params, nextFunc);
            }
            // callback.call(this, preValue);

            function createNextFunc(index) {
                return function(value){
                    if(index<len){
                        let config = funcConfigs[index];
                        return functions[config.func].call(this, value, config.params, createNextFunc(index+1));
                    }else{
                        return callback.call(this, value);
                    }
                }
            }
        }
    },
}
</script>